export const leadsLogFilterOptions = [
    { label: "Date Assigned", value: false },
    { label: "Lead Value", value: false },
    { label: "Products", value: false },
    { label: "Lead Status", value: false },
  ];

export const LEAD_STATUS_OPTIONS = [
  "New Lead",
  "In Progress",
  "Qualified",
  "Not Qualified",
  "Contact Attempted",
  "Converted",
  "Closed-Won",
  "Closed-Lost",
];

export const INTERESTED_PRODUCT_OPTIONS = [
  "Preneed Product",
  "At-need Product",
  "Consultation",
  "Miscellaneous",
];